import type { SidebarTreeApiFolderNode } from '@/shared/constant/sidebar-tree/SidebarTreeNode';
import clsx from 'clsx';
import React from 'react';
import styles from '../../SidebarTree.module.css';
import { SidebarTreeList } from '../sidebar-tree-list/SidebarTreeList';

export type SidebarModuleFolderProps = {
  value: SidebarTreeApiFolderNode;
  indentation: number;
  index: number;
  isHidden: boolean;
};

export const SidebarModuleFolder = React.memo(function SidebarModuleFolderComponent(
  props: SidebarModuleFolderProps,
) {
  const { value, indentation, index, isHidden } = props;
  const { name, children } = value;

  return (
    <li
      className={clsx({
        ['my-4']: !(indentation === 0 && index === 0),
      })}
    >
      <div
        className={clsx(styles['sidebar-tree-node'], 'cursor-default hover:bg-transparent')}
        title={name}
      >
        <span className="truncate text-fill-7">{name}</span>
      </div>

      <SidebarTreeList list={children} indentation={indentation} isHidden={isHidden} />
    </li>
  );
});
